module.exports = __webpack_public_path__ + "img/sleeve_cap.5615a5e8.png";